import { render, staticRenderFns } from "./InsuranceIndex.vue?vue&type=template&id=16f93abd&scoped=true"
import script from "./InsuranceIndex.vue?vue&type=script&lang=js"
export * from "./InsuranceIndex.vue?vue&type=script&lang=js"
import style0 from "./InsuranceIndex.vue?vue&type=style&index=0&id=16f93abd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16f93abd",
  null
  
)

export default component.exports